module.exports = __webpack_public_path__ + "static/img/push-icon.db0e5b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/push-icon.png
// module id = hZ3y
// module chunks = 130